import { OrgDetails as OrgDetailsModule } from "../modules/OrgDetails/OrgDetails";

const OrgDetails = () => {
  return <OrgDetailsModule />;
};

export default OrgDetails;
